<template>
  <el-dialog
    :model-value="visible"
    title="新增文本版本"
    width="560px"
    :close-on-click-modal="false"
    @update:model-value="$emit('update:visible', $event)"
  >
    <el-form :model="form" label-width="80px" label-position="top">
      <el-form-item label="文本内容" required>
        <el-input
          v-model="form.textContent"
          type="textarea"
          :rows="10"
          placeholder="输入新版本文本内容（最大 200KB）"
          maxlength="204800"
          show-word-limit
        />
      </el-form-item>
      <el-form-item label="版本备注">
        <el-input v-model="form.changeRemark" placeholder="说明本次变更" maxlength="500" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :disabled="!form.textContent" :loading="submitting" @click="handleSubmit">
        保存版本
      </el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { reactive, ref, watch } from 'vue'
import { ElMessage } from 'element-plus'
import { createTextVersion } from '@/api/assets'

const props = defineProps({
  visible: { type: Boolean, default: false },
  asset: { type: Object, default: null }
})

const emit = defineEmits(['update:visible', 'success'])

const form = reactive({
  textContent: '',
  changeRemark: ''
})
const submitting = ref(false)

watch(() => props.visible, (val) => {
  if (val) {
    form.textContent = props.asset?.currentVersion?.textContent || ''
    form.changeRemark = ''
  }
})

function handleCancel() {
  emit('update:visible', false)
}

async function handleSubmit() {
  if (!props.asset?.id || !form.textContent) return
  submitting.value = true
  try {
    await createTextVersion(props.asset.id, {
      textContent: form.textContent,
      changeRemark: form.changeRemark || undefined
    })
    ElMessage.success('文本版本已创建')
    emit('success')
    emit('update:visible', false)
  } catch {
    // handled by interceptor
  } finally {
    submitting.value = false
  }
}
</script>
